export const PRESIDENT_CARD_BRAND_NAME = 'PRESIDENT_CARD'

export const BRAND_NAMES = {
  PRESIDENT_CARD: 'PRESIDENT CARD',
  UPSIDER: 'UPSIDER',
}

export const BRAND_LOGO_PATHS = {
  PRESIDENT_CARD: '/_images/president/president-card-logo.svg',
  UPSIDER: '/_images/logo-black.svg',
}
